import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import TelegramOnly from './components/TelegramOnly';
import { useAppImageWarmup } from './hooks/useAppImageWarmup';

// Lazy load pages for code splitting
const HomePage = lazy(() => import('./pages/HomePage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const ShopPage = lazy(() => import('./pages/ShopPage'));
const StoriesPage = lazy(() => import('./pages/StoriesPage'));
const PassportPage = lazy(() => import('./pages/PassportPage'));
const NightPage = lazy(() => import('./pages/NightPage'));
const AssetsPage = lazy(() => import('./pages/AssetsPage'));
const ScoresPage = lazy(() => import('./pages/ScoresPage'));
const ReferralPage = lazy(() => import('./pages/ReferralPage'));

// Loading component
const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#FFB6C1',
    color: '#FF69B4',
    fontSize: '1.5rem'
  }}>
    در حال بارگذاری...
  </div>
);

// Conditional wrapper that allows /passport without Telegram
function ConditionalTelegramOnly({ children }) {
  const location = useLocation();
  const isPassportRoute = location.pathname === '/passport';
  
  if (isPassportRoute) {
    return children;
  }
  
  return <TelegramOnly>{children}</TelegramOnly>;
}

function AppRoutes() {
  useAppImageWarmup();

  return (
    <ConditionalTelegramOnly>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route 
            path="/register" 
            element={<RegisterPage />} 
          />
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/shop" 
            element={
              <ProtectedRoute>
                <ShopPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/stories" 
            element={
              <ProtectedRoute>
                <StoriesPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/passport" 
            element={
              <ProtectedRoute>
                <PassportPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/night" 
            element={
              <ProtectedRoute>
                <NightPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/assets" 
            element={
              <ProtectedRoute>
                <AssetsPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/scores" 
            element={
              <ProtectedRoute>
                <ScoresPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/referral" 
            element={
              <ProtectedRoute>
                <ReferralPage />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Suspense>
    </ConditionalTelegramOnly>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
